<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 24/9/2020
  -->

<template>
	<BaseNotification ref="notification">
		<div class="card p-3 m-3">
			<SavingIndicator ref="indicator"/>
		</div>
	</BaseNotification>

</template>

<script>
import BaseNotification from "@/core/components/Notifications/BaseNotification.vue";
import SavingIndicator from "@/core/components/SavingIndicator.vue";
export default {
	name: "SavingNotification",
	components: {SavingIndicator, BaseNotification},
	extends:BaseNotification,

	methods:{
		async show(){
			this.notification.show()
			this.indicator.show()
		},
		async hideSuccess(){
			await this.indicator.hideSuccess()
			this.notification.hide()
		},

		async hideFailed(){
			await this.indicator.hideFailed()
			this.notification.hide()
		}
	},

	computed: {

		notification(){
			return this.$refs.notification
		},

		indicator(){
			return this.$refs.indicator
		},
	}
}
</script>

<style lang="scss">

</style>
